import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DataGridUtil } from '../datagrid/datagrid.util'
import { Format } from '../datagrid/format';

export interface GridAction {
  action: string,
  values: {
    key: string,
    value: string
  }[]
}

@Component({
  selector: 'detail-grid',
  styleUrls: ['./detailgrid.style.css'],
  templateUrl: './detailgrid.component.html'
})

export class DetailGrid {

  //Input Variables
  @Input() columns: any[];
  @Input() data: any;
  
  @Input() gridbtns: any[];
  @Input() hdrbtns: any[];
  @Input() isshowfilter: boolean;
  @Input() filter: any;


  //Output Variable
  @Output()
  btnclick: EventEmitter<GridAction> = new EventEmitter<GridAction>();

  //Local Variable
  pdata: any;
  listFilter: string;
  searchTitle: string = "Search:";

  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.data;
    this.criteriaChange(this.listFilter);
  }




  click(btn: any, row: any): void {
    let keyds = <GridAction>{};
    keyds.action = btn.action;

    if (row != null) {
      keyds.values = [];
      btn.keys.forEach((key: any) => {
        keyds.values.push({ key: key, value: row[key] });
      });
    }
    this.btnclick.emit(keyds);
  }

  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        this.pdata = this.filter.transform(this.data, this.listFilter);
      }
    }
  }



}
